import * as B from '@blueprintjs/core';
import React from 'react';

import zoomCs from 'app/components/DeclarativeMap/ZoomCenterControl.module.scss';
import {recordEvent} from 'app/tools/Analytics';

import {useGrid} from './GridContext';

/**
 * Toolbar toggle for the grid review tool. Self-contained: reads grid context,
 * owns its analytics, renders the same B.AnchorButton style as the other
 * ZoomCenterControl fit-buttons so it slots cleanly into `additionalFitButtons`.
 */
const GridToolButton: React.FunctionComponent = () => {
  const {isEnabled, setIsEnabled, projectId, featureId, isPickingGridSize} = useGrid();

  const handleClick = () => {
    const opening = !isEnabled;
    setIsEnabled(opening);
    if (opening) {
      recordEvent('Opened grid review tool', {
        // True when reopening an already-committed grid (skips the picker).
        hasSavedGrid: !isPickingGridSize,
        projectId,
        ...(featureId != null && {featureId}),
      });
    }
  };

  return (
    <B.Tooltip
      content={isEnabled ? 'Close grid review tool' : 'Open grid review tool'}
      position={B.Position.LEFT}
    >
      <B.AnchorButton
        icon="grid-view"
        className={zoomCs.btn}
        active={isEnabled}
        onClick={handleClick}
      />
    </B.Tooltip>
  );
};

export default GridToolButton;
